"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCESS_TOKEN = exports.RESTRICT_ACCESS = exports.getRoomURL = exports.getGameURL = exports.ROOM_ENDPOINT = exports.GAME_ENDPOINT = exports.getAvatarPath = exports.PUBLIC_ASSETS = exports.AVATAR_API = void 0;
exports.AVATAR_API = "https://avatars.dicebear.com/api/";
exports.PUBLIC_ASSETS = "https://raw.githubusercontent.com/unboared/public-assets/main/";
const getAvatarPath = (avatarName) => {
    return `${exports.AVATAR_API}${avatarName}`;
};
exports.getAvatarPath = getAvatarPath;
exports.GAME_ENDPOINT = "/game/";
exports.ROOM_ENDPOINT = "/gamepad/";
const getGameURL = (host, game) => {
    return host + exports.GAME_ENDPOINT + game;
};
exports.getGameURL = getGameURL;
const getRoomURL = (host, room) => {
    return host + exports.ROOM_ENDPOINT + room;
};
exports.getRoomURL = getRoomURL;
exports.RESTRICT_ACCESS = true;
exports.ACCESS_TOKEN = "WeLoveGames";
//# sourceMappingURL=config.js.map